export const INPROGRESS_TAB_VALUE = "inprogress"
export const FULLORDER_TAB_VALUE = "fullorder"
export const SHIPPED_TAB_VALUE = "shipped"
export const RETURNED_TAB_VALUE = "returned"
export const CANCELLED_TAB_VALUE = "cancelled"

export const FULLORDER_TAB_ANALYTICS = "Full Order"
export const SHIPPED_TAB_ANALYTICS = "Shipped"
export const INPROGRESS_TAB_ANALYTICS = "In Progress"
export const RETURNED_TAB_ANALYTICS = "Returned"
export const CANCELLED_TAB_ANALYTICS = "Cancelled"

export const TAB_ANALYTICS_EVENT = "my account:orders:order details"

export const ODP_TRACKINGLINK_ANALYTICS_EVENT_NAME =
  "my account:orders:order details"

export const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_NAME = "track package"
export const ODP_TRACKINGLINK_ANALYTICS_INTERNAL_LINK_POSITION = "my account"
export const ODP_ORDER_SUPPORT_EVENT = "my account:orders:order summary"
export const ODP_ANALYTICS_PAGE = "orders"
export const ODP_ANALYTICS_ACCOUNT = "my account"
export const ODP_ANALYTICS_ORDER_SUPPORT = "order details:order support"
export const ODP_ANALYTICS_NAVIGATION = "navigation"
export const ODP_CUSTOMER_SUPPORT_LINK_TYPE = "order details:customer support"

export const LINE_ITEM_STATUS_CANCELLED = "Cancelled"
export const LINE_ITEM_STATUS_INPROGRESS = "In Progress"
export const LINE_ITEM_STATUS_RETURN_CREATED = "Return Created"
export const LINE_ITEM_STATUS_SHIPPED = "Shipped"
export const LINE_ITEM_STATUS_RETURN_REQUESTED = "Return Requested"
export const LINE_ITEM_STATUS_RETURN_ACCEPTED = "Return Accepted"
export const LINE_ITEM_STATUS_RETURN_REJECTED = "Return Rejected"
export const LINE_ITEM_STATUS_RETURN_CANCELLED = "Return Cancelled"

export const ORDER_TYPE_PARCEL = "Parcel"
export const ORDER_TYPE_FREIGHT = "Freight"
export const ORDER_TYPE_SERVICE = "Service"

export const TABS_TO_SORT = [
  SHIPPED_TAB_VALUE,
  INPROGRESS_TAB_VALUE,
  CANCELLED_TAB_VALUE,
]

export const NON_SHIPPED_TABS = [
  RETURNED_TAB_VALUE,
  INPROGRESS_TAB_VALUE,
  CANCELLED_TAB_VALUE,
]

export const RETURN_STATUS_SORT_ORDER = [
  LINE_ITEM_STATUS_RETURN_REQUESTED,
  LINE_ITEM_STATUS_RETURN_ACCEPTED,
  LINE_ITEM_STATUS_RETURN_REJECTED,
  LINE_ITEM_STATUS_RETURN_CANCELLED,
]

export const ORDER_TYPES_SORT_SEQUENCE = [
  ORDER_TYPE_PARCEL,
  ORDER_TYPE_FREIGHT,
  ORDER_TYPE_SERVICE,
]

export const SERVICES_SHIPPING_TYPE = ["INSTALL SERVICES", "DESIGN SERVICES"]
